import { queryOptions, type TQueryKey } from '@react/utils/queryHooks';

import type { IQuoteVMProps } from '@data/view-models';

import { QK_FETCH_QUOTES, quoteApi } from '~/requests/quoteApi';

export type TQuotesOptions = Omit<
  ReturnType<
    typeof queryOptions<
      IQuoteVMProps[],
      Error,
      IQuoteVMProps[],
      Array<TQueryKey>
    >
  >,
  'queryFn'
>;

export function quotesOptions(): TQuotesOptions {
  return queryOptions({
    queryKey: [QK_FETCH_QUOTES],
    queryFn: async ({ signal }) => {
      return quoteApi.getQuotes({
        signal,
      });
    },
  });
}
